import { useState, useEffect } from 'react';

import { Button, Column, Text } from '../../uixy';

import styles from './index.module.css';

export const Calendar = () => {
    const initialDate = new Date();

    const [currentDate, setCurrentDate] = useState(initialDate);
    const [notes, setNotes] = useState(() => {
        return JSON.parse(localStorage.getItem('calendarNotes')) || {};
    });

    useEffect(() => {
        localStorage.setItem('calendarNotes', JSON.stringify(notes));
    }, [notes]);

    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    const weekDay = new Date(currentYear, currentMonth, 0).getDay();
    const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const lastDayOfPrevMonth = new Date(currentYear, currentMonth, 0).getDate();

    const days = [];

    const handleNoteChange = (day, event) => {
        setNotes({
            ...notes,
            [`${currentYear}-${currentMonth}-${day}`]: event.target.innerText,
        });
    };

    for (let i = weekDay - 1; i >= 0; i--) {
        days.push(
            <div key={`prev_${i}`} className={styles.day}>
                <Text>{lastDayOfPrevMonth - i}</Text>
            </div>,
        );
    }

    for (let i = 1; i <= lastDayOfMonth; i++) {
        const noteKey = `${currentYear}-${currentMonth}-${i}`;

        const isToday =
            initialDate.getDate() === i &&
            currentDate.getMonth() === initialDate.getMonth() &&
            currentDate.getFullYear() === initialDate.getFullYear();

        days.push(
            <div key={i} className={styles.currentMonthDay}>
                <p
                    style={
                        isToday
                            ? {
                                  color: 'var(--sysErrorColor)',
                              }
                            : undefined
                    }
                >
                    {i}
                </p>
                <div
                    contentEditable
                    className={styles.note}
                    onBlur={(event) => handleNoteChange(i, event)}
                    suppressContentEditableWarning={true}
                >
                    {notes[noteKey] || ''}
                </div>
            </div>,
        );
    }

    while (days.length % 7 !== 0) {
        days.push(
            <div key={`next_${days.length}`} className={styles.day}>
                <Text>{days.length - lastDayOfMonth - (weekDay - 1)}</Text>
            </div>,
        );
    }

    const weekDays = Array.from({ length: 7 }, (_, i) => {
        const date = new Date();
        date.setDate(date.getDate() - date.getDay() + i + 1); // Сдвигаем к понедельнику

        return new Intl.DateTimeFormat('default', { weekday: 'short' })
            .format(date)
            .slice(0, 2); // Ограничиваем до 2 символов;
    });

    // Функция смены месяца
    const changeMonth = (offset) => {
        setCurrentDate(
            (prev) => new Date(prev.getFullYear(), prev.getMonth() + offset, 1),
        );
    };

    const [offsetX, setOffsetX] = useState(0);
    const [startX, setStartX] = useState(0);
    const [dragging, setDragging] = useState(false);
    const [opacity, setOpacity] = useState(1);

    // Начало свайпа
    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX);
        setDragging(true);
    };

    // Движение пальца
    const handleTouchMove = (e) => {
        if (!dragging) return;
        const moveX = e.touches[0].clientX - startX;
        setOffsetX(moveX);
        setOpacity(1 - Math.min(Math.abs(moveX) / 200, 1));
    };

    // Завершение свайпа
    const handleTouchEnd = () => {
        setDragging(false);

        if (offsetX < -50) {
            // Свайп влево → следующий месяц
            setOffsetX(-window.innerWidth);
            setTimeout(() => {
                changeMonth(1);
                setOffsetX(0);

                setTimeout(() => {
                    setOpacity(1);
                }, 100);
            }, 200);
        } else if (offsetX > 50) {
            // Свайп вправо → предыдущий месяц
            setOffsetX(window.innerWidth);
            setTimeout(() => {
                changeMonth(-1);
                setOffsetX(0);

                setTimeout(() => {
                    setOpacity(1);
                }, 100);
            }, 200);
        } else {
            // Вернуть календарь на место
            setOffsetX(0);
            setOpacity(1);
        }
    };

    return (
        <Column
            gap={4}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{ overflow: 'hidden' }}
        >
            <div className={styles.controls}>
                <Button onClick={() => changeMonth(-1)}>&larr;</Button>
                <span>
                    {currentDate.toLocaleString('default', {
                        month: 'long',
                        year: 'numeric',
                    })}
                </span>
                <Button onClick={() => changeMonth(1)}>&rarr;</Button>
            </div>

            <Column
                gap={1}
                style={{
                    transform: `translateX(${offsetX}px)`,
                    opacity,
                    transition:
                        offsetX === 0
                            ? 'none, opacity 0.1s ease-out'
                            : 'transform 0.2s ease-out, opacity 0.1s ease-out',

                    overflow: 'auto',
                    overscrollBehavior: 'contain',
                }}
            >
                <div className={styles.weekDays}>
                    {weekDays.map((weekDay) => {
                        return <div key={weekDay}>{weekDay}</div>;
                    })}
                </div>

                <div className={styles.calendar}>{days}</div>
            </Column>
        </Column>
    );
};
